import React, { useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { makeStyles } from '@material-ui/core/styles';
import {
	CssBaseline,
	Container,
	Paper,
	Typography,
	Button,
	TextField,
} from '@material-ui/core';
import { Helmet } from 'react-helmet-async';
import { NavLink, useNavigate } from 'react-router-dom';
import {
	useAddAuthorMutation,
	useAddCategoryMutation,
	useDeleteAuthorMutation,
	useUpdateAuthorMutation,
} from '../../../store/apiSlice';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		alignItems: 'center',
	},
	container: {
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
	},
	paper: {
		padding: theme.spacing(2),
	},
	title: {
		paddingBottom: theme.spacing(2),
	},
	backButton: {
		marginBottom: theme.spacing(2),
	},
}));

export function CategoryCreate(props) {
	const classes = useStyles();
	const navigate = useNavigate();

	const [newCategoryName, setNewCategoryName] = useState('');
	const [addCategory] = useAddCategoryMutation();
	const handleAdd = (e) => {
		addCategory({ name: newCategoryName });
		navigate('/admin/categories');
	};

	return (
		<div className={classes.root}>
			<CssBaseline />
			<Helmet>
				<title>Нова категория</title>
			</Helmet>

			<Container maxWidth="lg" className={classes.container}>
				<Paper className={classes.paper}>
					<Typography
						className={classes.title}
						component="h1"
						variant="h4"
						role="alert"
					>
						Нова категория
					</Typography>

					<TextField
						value={newCategoryName}
						onChange={(e) => setNewCategoryName(e.target.value)}
						placeholder="Име на категорията"
					></TextField>
					<Button startIcon={<EditIcon />} onClick={handleAdd}>
						Запис
					</Button>
				</Paper>
			</Container>
		</div>
	);
}
